
export class DialogMessage {

  constructor(public type: string,
              public message: any) {
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/dialog-messages/dialog-message.model.ts